import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useCallback, useMemo } from 'react';
import { createHook, createStore } from 'react-sweet-state';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { fireTrackAnalytics } from '@atlassian/analytics-bridge';
import { Action, ActionSubject } from '@atlassian/proforma-utils/analytics';
var initialState = {
  errorsByQuestionId: {}
};
var actions = {
  set: function set(errorsByQuestionId) {
    return function (_ref) {
      var setState = _ref.setState;
      return setState({
        errorsByQuestionId: errorsByQuestionId
      });
    };
  },
  setFromJiraFieldErrors: function setFromJiraFieldErrors(form, jiraFieldErrors) {
    return function (_ref2) {
      var setState = _ref2.setState;
      var formQuestionsByJiraField = form.questions.reduce(function (accQuestions, question) {
        var jiraField = question.formQuestion.jiraField;
        if (!jiraField) {
          return accQuestions;
        }
        return _objectSpread(_objectSpread({}, accQuestions), {}, _defineProperty({}, jiraField, question));
      }, {});
      var errorsByQuestionId = Object.entries(jiraFieldErrors).reduce(function (accErrorsByQuestionId, _ref3) {
        var _formQuestionsByJiraF, _formQuestionsByJiraF2;
        var _ref4 = _slicedToArray(_ref3, 2),
          jiraField = _ref4[0],
          error = _ref4[1];
        var questionId = ((_formQuestionsByJiraF = formQuestionsByJiraField[jiraField]) === null || _formQuestionsByJiraF === void 0 ? void 0 : _formQuestionsByJiraF.id) && Number((_formQuestionsByJiraF2 = formQuestionsByJiraField[jiraField]) === null || _formQuestionsByJiraF2 === void 0 ? void 0 : _formQuestionsByJiraF2.id);
        if (!questionId) {
          return accErrorsByQuestionId;
        }
        return _objectSpread(_objectSpread({}, accErrorsByQuestionId), {}, _defineProperty({}, questionId, error));
      }, {});
      setState(_objectSpread(_objectSpread({}, initialState), {}, {
        errorsByQuestionId: errorsByQuestionId
      }));
    };
  },
  clear: function clear() {
    return function (_ref5) {
      var setState = _ref5.setState;
      return setState(initialState);
    };
  }
};
var Store = createStore({
  initialState: initialState,
  actions: actions,
  name: "FormSaveErrors"
});
var useFormSaveErrors = createHook(Store);
export var useFormSaveErrorsActions = function useFormSaveErrorsActions() {
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  var _useFormSaveErrors = useFormSaveErrors(),
    _useFormSaveErrors2 = _slicedToArray(_useFormSaveErrors, 2),
    _useFormSaveErrors2$ = _useFormSaveErrors2[1],
    set = _useFormSaveErrors2$.set,
    setFromJiraFieldErrors = _useFormSaveErrors2$.setFromJiraFieldErrors,
    clear = _useFormSaveErrors2$.clear;
  var setWithAnalytics = useCallback(function (errorsByQuestionId) {
    if (Object.keys(errorsByQuestionId).length > 0) {
      fireTrackAnalytics(createAnalyticsEvent({}), "".concat(ActionSubject.FORM_SAVE, " ").concat(Action.STOPPED));
    }
    set(errorsByQuestionId);
  }, [createAnalyticsEvent, set]);
  var setWithJiraFieldErrorsWithAnalytics = useCallback(function (form, jiraFieldErrors) {
    if (Object.keys(jiraFieldErrors).length > 0) {
      fireTrackAnalytics(createAnalyticsEvent({}), "".concat(ActionSubject.FORM_SAVE, " ").concat(Action.STOPPED));
    }
    setFromJiraFieldErrors(form, jiraFieldErrors);
  }, [createAnalyticsEvent, setFromJiraFieldErrors]);
  return useMemo(function () {
    return {
      set: setWithAnalytics,
      setFromJiraFieldErrors: setWithJiraFieldErrorsWithAnalytics,
      clear: clear
    };
  }, [clear, setWithAnalytics, setWithJiraFieldErrorsWithAnalytics]);
};
export var useFormSaveQuestionError = function useFormSaveQuestionError(questionId) {
  var _useFormSaveErrors3 = useFormSaveErrors(),
    _useFormSaveErrors4 = _slicedToArray(_useFormSaveErrors3, 1),
    errorsByQuestionId = _useFormSaveErrors4[0].errorsByQuestionId;
  return errorsByQuestionId[questionId];
};